<template>
  <svg
    class="arrow-down-icon"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M17.5 6.25L9.99996 13.75L2.5 6.25" stroke="#2350AC" stroke-width="2" stroke-miterlimit="10" />
  </svg>
</template>
